import React from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Search } from '@brainstormforce/starter-templates-components';
import { __ } from '@wordpress/i18n';
import { queryParamDelete, queryNavigation } from '../utils/query-navigation';
import { useFilteredSites } from '../../util/helper-functions';
import './style.scss';

const SearchFilter = ( { siteData, setSiteData } ) => {
	const { searchTerm, pageBuilder, filterplan, showSearchBox } = useSelector(
		( state ) => state
	);
	const sites = useFilteredSites();
	const dispatch = useDispatch();

	return showSearchBox
		? createPortal(
			<div className="st-showcase-search-wrapper">
				<div
					id="st-showcase-search-box-wrapper"
					className="st-showcase-search-box-wrapper"
				>
					<div className="st-showcase-search-filter">
						<Search
							apiUrl={ `${ AstraShowcaseVars.api_domain }wp-json/starter-templates/v2/sites-search/?search=${ searchTerm }&page-builder=${ pageBuilder }&type=${ filterplan }` }
							beforeSearchResult={ () => {
								if ( !! searchTerm ) {
									setSiteData( {
										...siteData,
										gridSkeleton: true,
									} );
								}
							} }
							onSearchResult={ ( response ) => {
								const results = [];
								if ( response.success ) {
									if ( response.ids.length ) {
										for ( const id of response.ids ) {
											if ( sites[ id ] ) {
												results[ id ] = sites[ id ];
											}
										}
									}
								}

								setSiteData( {
									...siteData,
									sites: searchTerm ? results : sites,
									gridSkeleton: false,
								} );
							} }
							placeholder={ __(
								'Search…',
								'astra-sites-showcase'
							) }
							value={ searchTerm }
							onSearch={ ( event, newSearchTerm ) => {
								if ( newSearchTerm === '' ) {
									queryParamDelete( 'search' );
								} else {
									queryNavigation(
										'search',
										newSearchTerm
									);
								}
								dispatch( {
									type: 'set',
									searchTerm: newSearchTerm,
									filtercategories: '',
									selectedMegaMenu: '',
									siteBusinessType: '',
								} );
								setSiteData( {
									...siteData,
									gridSkeleton: true,
								} );
							} }
						/>
					</div>
				</div>
			</div>,
			document.getElementById( 'astra-sites-search-box' )
		)
		: null;
};

export default SearchFilter;
